export default __webpack_public_path__ + "static/media/10c0192b7de692b451ca7cb297943fdde7a047beb52c24e91c3124f94fad4da3.2aeeb191.png";